import store from "@packages/store";
import Vue from "vue";

export default {
    async find(id) {
        return await Vue.api.local.find({ id });
    },

    async load({ pagination, filters, establishmentIds, isEstabelecimento }) {
        const local = isEstabelecimento
            ? await Vue.api.locals.load({
                  pagination,
                  filters,
              })
            : await Vue.api.locals.loadEstablishiments({
                  pagination,
                  filters,
                  establishmentIds,
              });

        store.commit("SET_DEVICES_LIST", local);
        store.commit("SET_DEVICES", local);

        return local;
    },

    async count({ filters }) {
        const count = await Vue.api.locals.count({ filters });

        store.commit("SET_DEVICES_COUNT", count);

        return count;
    },
};
